/* eslint-disable no-restricted-imports */
import { selectIsPostReported } from '../../data-layer/posts/selectors';
import { useSelector } from '../../data-layer/useSelector';

export const useIsPostReported = (postId: string): boolean =>
    useSelector((state) => selectIsPostReported(state, postId));
